import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceTaskComputed = {
	...mapState('taskCommCdStore', Object.keys(state)),
	...mapGetters('taskCommCdStore', Object.keys(getters))
};
export const serviceTaskMethods = {
	...mapActions('taskCommCdStore', Object.keys(actions)),
	...mapMutations('taskCommCdStore', Object.keys(mutations))
};